<template>
	<div class="dockpanel is-left is-hidden-print" :class="{'is-active':isActive}">
		<button class="delete" aria-label="close" @click="close"></button>
		<div class="dockpanel-body">
			<slot></slot>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			isActive: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			close() {
				this.$emit('close');
			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
	@import '../../assets/sass/main.scss'
	$dockpanel-top: $navbar-height !default
	$dockpanel-z: 29 !default
	$dockpanel-shadow: 5px 0px 13px 3px rgba( 0, 0, 0, 0.1 ) !default

	.dockpanel
		display: flex
		flex-direction: column
		background-color: $white
		border-right: 1px solid #D1D1D1
		max-width: calc( 100% - 85px )
		&.is-marginless
			max-width: 100%
		position: fixed
		top: $dockpanel-top
		bottom: 0
		z-index: $dockpanel-z
		transform: translateZ( 0 )
		transition: .3s ease
		backface-visibility: hidden
		perspective: 1000
		will-change: transform 
		+mobile
			width: 100%
			right: -100% 
		+tablet
			width: 50%
			right: -50% 
		+desktop
			width: 35%
			right: -35% 
		+widescreen
			width: 25%
			right: -25% 
		+fullhd
			width: 20%
			right: -20%
		&.is-left 
			+mobile
				left: -100% 
			+tablet
				left: -50% 
			+desktop
				left: -35% 
			+widescreen
				left: -25% 
			+fullhd
				left: -20%
		&.is-active
			right: 0
			box-shadow: $dockpanel-shadow
			&.is-left
				left: 0		
				&.is-2
					+mobile
						left: 0 
					+tablet
						left: 0 
					+desktop
						left: 35% 
					+widescreen
						left: 25% 
					+fullhd
						left: 20%

	.dockpanel-body
		-webkit-box-flex: 1
		flex: 1 1 0%
		overflow-y: auto

	.dockpanel>.delete
		position: absolute
		z-index:1000
		right: .5rem
		top: .5rem
</style>
